import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'

import dictionary from './dictionary'
import blank from './blank'
import packages from './packages'
import error from './error'
import loader from './loader'

const state = {
  layoutH: true,
  ph: {}
}

const getters = {
  ...make.getters(state)
}

const actions = {
  ...make.actions('items')
}

const mutations = make.mutations(state)

// store
Vue.use(Vuex)
export default new Vuex.Store({
  // properties
  state,
  getters,
  actions,
  mutations,

  // Elementy store zaimplementowane jako moduły
  modules: {
    blank,
    dictionary,
    packages,
    error,
    loader
  },

  // use the plugin
  plugins: [pathify.plugin]
})
